import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Enquiry/Enquiry/tables";
import headers from "../../../../Data/Tables/Enquiry/Enquiry/headers";
import { get_all_enquiries } from "../../../../Controllers/Enquiry/Enquiry";
import Header from "../../../../Components/Header";
import Loadercomponent from "../../../../Components/Loader";
import Table from "../../../../Components/Table";
import Status from "../../../../Components/Status";
import ActionButton from "../../../../Components/Buttons/action";
import moment from "moment";

const EnquiryTable = () => {
  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();

  const formdata = (data) => {
    fetchData(data);
  };

  const actiondata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const params = {
        search: tabledata?.search,
        enquiry: tabledata?.enquiry,
      };

      const contacts = await get_all_enquiries(params);

      if (contacts?.status) {
        let data = [];

        contacts?.data?.map((value, index) => {
          data?.push({
            Name: value?.name,
            Email: value?.email,
            Phone: value?.phone,
            Type: value?.type,
            Created: moment(value?.created).format("Do MMMM YYYY"),
          });
        });

        setBody(data);
        setLoader(false);
      } else {
        toast?.error(contacts?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header header={headers} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Table head={tables} body={body} />
      </Loadercomponent>
    </Header>
  );
};

export default EnquiryTable;
